import { LinkedAccount } from "../../../../../../models/Entities";
import { useRequest } from "../../../../../shared/hooks/useRequest";

interface Params {
  linkedAccount: LinkedAccount;
}

interface SharepointSyncConfig {
  sync_onedrive_content: boolean;
}

const useLoadLinkedAccountSharepointSyncConfig = ({ linkedAccount }: Params) => {
  const isSharePoint = linkedAccount?.integration?.slug?.toLowerCase() === "sharepoint";

  const { loading, data } = useRequest<SharepointSyncConfig>({
    path: `integrations/selective-sync/linked-account/${linkedAccount.id}/sharepoint-sync-config`,
    errorText: "Error loading SharePoint sync config",
    skip: !isSharePoint,
  });

  return {
    syncOneDriveContent: data?.sync_onedrive_content,
    loading,
  };
};

export default useLoadLinkedAccountSharepointSyncConfig;
